import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { IonAccordionGroup } from '@ionic/angular';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent implements OnChanges {
  @Input() rainbow;
  @Input() palette = [];
  @Input() selectedColor;
  @Input() id = 'accordion';
  @Input() heartrate = false;
  @Input() label = 'Color';
  @Output() colorSelected = new EventEmitter<string>();
  @ViewChild('accordionGroup', { static: true })
  accordionGroup: IonAccordionGroup;

  colorIndex = -1;
  paletteIndex = -1;
  rainbowIndex = -1;

  colors = [
    'MediumVioletRed',
    'DeepPink',
    'PaleVioletRed',
    'HotPink',
    'LightPink',
    'Pink',
    'DarkRed',
    'Red',
    'Firebrick',
    'Crimson',
    'IndianRed',
    'LightCoral',
    'Salmon',
    'DarkSalmon',
    'LightSalmon',
    'OrangeRed',
    'Tomato',
    'DarkOrange',
    'Coral',
    'Orange',
    'DarkKhaki',
    'Gold',
    'Khaki',
    'PeachPuff',
    'Yellow',
    'PaleGoldenrod',
    'Moccasin',
    'PapayaWhip',
    'LightGoldenrodYellow',
    'LemonChiffon',
    'LightYellow',
    'Maroon',
    'Brown',
    'SaddleBrown',
    'Sienna',
    'Chocolate',
    'DarkGoldenrod',
    'Peru',
    'RosyBrown',
    'Goldenrod',
    'SandyBrown',
    'Tan',
    'Burlywood',
    'Wheat',
    'NavajoWhite',
    'Bisque',
    'BlanchedAlmond',
    'Cornsilk',
    'DarkGreen',
    'Green',
    'DarkOliveGreen',
    'ForestGreen',
    'SeaGreen',
    'Olive',
    'OliveDrab',
    'MediumSeaGreen',
    'LimeGreen',
    'Lime',
    'SpringGreen',
    'MediumSpringGreen',
    'DarkSeaGreen',
    'MediumAquamarine',
    'YellowGreen',
    'LawnGreen',
    'Chartreuse',
    'LightGreen',
    'GreenYellow',
    'PaleGreen',
    'Teal',
    'DarkCyan',
    'LightSeaGreen',
    'CadelBlue',
    'DarkTurquoise',
    'MediumTurquoise',
    'Turquoise',
    'Aqua',
    'Cyan',
    'AquaMarine',
    'PaleTurquoise',
    'LightCyan',
    'Navy',
    'DarkBlue',
    'MediumBlue',
    'Blue',
    'MidnightBlue',
    'RoyalBlue',
    'SteelBlue',
    'DodgerBlue',
    'DeepSkyBlue',
    'CornFlowerBlue',
    'SkyBlue',
    'LightSkyBlue',
    'LightSteelBlue',
    'LightBlue',
    'PowderBlue',
    'Indigo',
    'Purple',
    'DarkMagenta',
    'DarkViolet',
    'DarkSlateBlue',
    'BlueViolet',
    'DarkOrchid',
    'Fuchsia',
    'Magenta',
    'SlateBlue',
    'MediumSlateBlue',
    'MediumOrchid',
    'MediumPurple',
    'Orchid',
    'Violet',
    'Plum',
    'Thistle',
    'Lavender',
    'MistyRose',
    'AntiqueWhite',
    'Linen',
    'Beige',
    'WhiteSmoke',
    'LavenderBlush',
    'OldLace',
    'AliceBlue',
    'Seashell',
    'GhostWhite',
    'Honeydew',
    'ForalWhite',
    'Azure',
    'MintCream',
    'Snow',
    'Ivory',
    'White',
    'Black',
    'DarkSlateGray',
    'DimGray',
    'SlateGrey',
    'Gray',
    'LightSlateGray',
    'DarkGray',
    'Silver',
    'LightGray',
    'Gainsboro',
  ];

  constructor() {}

  ngOnChanges() {
    if (this.rainbow) {
      if (
        this.selectedColor instanceof CanvasGradient ||
        this.selectedColor?.indexOf('linear') > -1
      ) {
        this.rainbowIndex = 0;
      }
    }
    if (!this.rainbow && this.selectedColor) {
      this.rainbowIndex = -1;
      if (this.colors.indexOf(this.selectedColor) > -1) {
        this.colorIndex = this.colors.indexOf(this.selectedColor);
      }
      if (this.palette.indexOf(this.selectedColor) > -1) {
        this.paletteIndex = this.colors.indexOf(this.selectedColor);
      }
    }
  }

  selectRainbowColor(index) {
    this.rainbowIndex = index;
    this.selectedColor = 'rainbow';
    this.rainbowIndex = 0;
    this.colorIndex = -1;
    this.paletteIndex = -1;
    if (this.heartrate) {
      this.colorSelected.emit(
        'linear-gradient(90deg,#989898 10%, #00A8D8 30%, #00A860 50%, #F8A820 70%, #F04040 90%)'
      );
    } else {
      this.colorSelected.emit(
        'linear-gradient(90deg,blue 0%, rgba(14,251,31,1) 33%, rgba(243,255,0,1) 66%, rgba(255,0,0,1) 100%)'
      );
    }

    this.toggleAccordion();
  }

  selectColor(index) {
    this.rainbowIndex = -1;
    this.selectedColor = this.colors[index];
    this.colorIndex = index;
    this.paletteIndex = -1;
    this.colorSelected.emit(this.selectedColor);

    this.toggleAccordion();
  }

  selectPaletteColor(index) {
    this.rainbowIndex = -1;
    this.selectedColor = this.palette[index];
    this.colorIndex = -1;
    this.paletteIndex = index;
    this.colorSelected.emit(this.selectedColor);
    this.toggleAccordion();
  }

  toggleAccordion = () => {
    const nativeEl = this.accordionGroup;
    if (nativeEl.value === 'second') {
      nativeEl.value = undefined;
    } else {
      nativeEl.value = 'second';
    }
  };
}
